import { Image } from 'antd';
import { Modal } from 'components/UI/Modal/styled';
import PdfViewer from 'components/UI/PdfViewer';
import React from 'react';

import s from './AttachmentPreview.module.less';

interface Props {
  name?: string;
  url: string | undefined;
  isPDF?: boolean;
  modalVisible: boolean;
  closeModal: () => void;
}

export const AttachmentPreview: React.FC<Props> = (props) => {
  const { isPDF, url, name, modalVisible, closeModal } = props;

  return (
    <>
      {!isPDF && url && modalVisible && (
        <Image
          width={200}
          src={url}
          classNames={{ root: s.imageWrapper }}
          preview={{
            open: modalVisible,
            onOpenChange: closeModal,
          }}
        />
      )}

      {isPDF && modalVisible && url && (
        <Modal
          className={s.modal}
          isFullPage
          isFullHeight
          title={name}
          open
          footer={null}
          onCancel={closeModal}
          destroyOnHidden
        >
          <PdfViewer className={s.pdfViewer} src={url} />
        </Modal>
      )}
    </>
  );
};
